import React from "react"
import ComingSoonPage from "../components/ComingSoonPage"

const StaffSelection = (): JSX.Element => {
  return <ComingSoonPage header="ஸ்டாஃப் செலக்‌ஷன் கமிஷன்" />
}

export default StaffSelection
